import AddUser from "../pages/users/addUser/AddUser";
import AuthGuard from "../components/guards/AuthGuard";
import AuthLanding from "../pages/auth/signIn/AuthLanding";
import AuthLayout from "../layouts/AuthLayout/Auth";
import Books from "../pages/books";
import DashboardLayout from "../layouts/dashboard";
import EditBook from "../pages/books/EditBook";
import EditUser from "../pages/users/EditUser";
import FirstLogin from "../pages/auth/firstLoginScreen";
import Fulfilments from "../pages/fulfilments";
import GuestGuard from "../components/guards/GuestGuard";
import ListOfUsers from "../pages/users";
import Logout from "../pages/logout";
import LogoutScreen from "../pages/auth/logoutScreen";
import MyAccount from "../pages/myAccount";
import { Outlet } from "react-router-dom";
import Page404 from "../pages/auth/Page404";
import Page500 from "../pages/auth/Page500";
import React from "react";
import ResetPassword from "../pages/auth/ResetPassword";
import SignUp from "../pages/auth/SignUp";
import Upload from "../pages/books/upload/Upload";
import async from "../components/Async";
import ForgotPassword from "../pages/auth/ForgotPassword";
import EditDistributor from "../pages/distributors/EditDistributor";
import AddDistributor from "../pages/distributors/AddDistributor";
import UpgradePlan from "../pages/upgradePlan";
import PaymentSuccess from "../pages/paymentsPages/PaymentSuccess";
import PaymentFailed from "../pages/paymentsPages/PaymentFailed";
import ListOfDistributors from "../pages/distributors";
import VerificationPage from "../pages/verificationPage";
import VerifyRegistrationPage from "../pages/auth/verifyRegistrationPage";
//import BaseComponents from "../pages/baseComponents";

//import ComplexComponents from "../pages/complexComponents";

// Dashboard components
const Default = async(() => import("../pages/dashboards/Default"));

const routes = [
  {
    path: "/",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: (
          <AuthGuard>
            <Default />
          </AuthGuard>
        ),
      },
      {
        path: "books",
        element: (
          <AuthGuard>
            <Outlet />
          </AuthGuard>
        ),
        children: [
          {
            index: true,
            element: <Books />,
          },
          {
            path: ":id",
            element: <EditBook />,
          },
          {
            path: "upload",
            element: <Upload />,
          },
        ],
      },
      {
        path: "fulfilments",
        element: (
          <AuthGuard>
            <Fulfilments />
          </AuthGuard>
        ),
      },
      {
        path: "myAccount",
        element: (
          <AuthGuard>
            <MyAccount />
          </AuthGuard>
        ),
      },
      {
        path: "users",
        element: (
          <AuthGuard>
            <Outlet />
          </AuthGuard>
        ),
        children: [
          {
            index: true,
            element: <ListOfUsers />,
          },
          {
            path: ":id",
            element: <EditUser />,
          },
          {
            path: "addUser",
            element: <AddUser />,
          },
        ],
      },
      // {
      //   path: "baseComponents",
      //   element: (
      //     <AuthGuard>
      //       <BaseComponents />
      //     </AuthGuard>
      //   ),
      // },
      // {
      //   path: "complexComponents",
      //   element: (
      //     <AuthGuard>
      //       <ComplexComponents />
      //     </AuthGuard>
      //   ),
      // },
      {
        path: "/distributors/addDistributor",
        element: (
          <AuthGuard>
            <AddDistributor />
          </AuthGuard>
        ),
      },
      {
        path: "/distributors/:id",
        element: (
          <AuthGuard>
            <EditDistributor />
          </AuthGuard>
        ),
      },
      {
        path: "/distributors",
        element: (
          <AuthGuard>
            <ListOfDistributors />
          </AuthGuard>
        ),
      },
      {
        path: "/upgradePlan",
        element: (
          <AuthGuard>
            <UpgradePlan />
          </AuthGuard>
        ),
      },

      {
        path: "logout",
        element: (
          <AuthGuard>
            <Logout />
          </AuthGuard>
        ),
      },
      {
        path: "initialize-pass",
        element: (
          <AuthGuard>
            <FirstLogin />
          </AuthGuard>
        ),
      },
    ],
  },
  {
    path: "auth",
    element: <AuthLayout />,
    children: [
      {
        path: "sign-in",
        element: (
          <GuestGuard>
            <AuthLanding />
          </GuestGuard>
        ),
      },
      {
        path: "sign-up",
        element: (
          <GuestGuard>
            <SignUp />
          </GuestGuard>
        ),
      },
      {
        path: "verify-registration",
        element: (
          <GuestGuard>
            <VerifyRegistrationPage />
          </GuestGuard>
        ),
      },
      {
        path: "verification",
        element: (
          <GuestGuard>
            <VerificationPage />
          </GuestGuard>
        ),
      },
      {
        path: "reset-password",
        element: (
          <GuestGuard>
            <ResetPassword />
          </GuestGuard>
        ),
      },
      {
        path: "forgot-password",
        element: (
          <GuestGuard>
            <ForgotPassword />
          </GuestGuard>
        ),
      },
      {
        path: "404",
        element: (
          <GuestGuard>
            <Page404 />
          </GuestGuard>
        ),
      },
      {
        path: "500",
        element: (
          <GuestGuard>
            <Page500 />
          </GuestGuard>
        ),
      },
      {
        path: "logout",
        element: (
          <GuestGuard>
            <LogoutScreen />
          </GuestGuard>
        ),
      },
    ],
  },
  {
    path: "paymentSuccess",
    element: (
      <AuthGuard>
        <PaymentSuccess />
      </AuthGuard>
    ),
  },

  {
    path: "paymentFailed",
    element: (
      <AuthGuard>
        <PaymentFailed />
      </AuthGuard>
    ),
  },
  {
    path: "*",
    element: <AuthLayout />,
    children: [
      {
        path: "*",
        element: <Page404 />,
      },
    ],
  },
];

export default routes;
